import FaqContainer from '../partialComponents/FaqContainer'
import BasicTemplate from '../templates/BasicTemplate'
import { faqs } from '../utils/faqs'
import StateBenefits from '../partialComponents/StateBenefits'
import { benefits } from '../utils/benefits'
import Academic from '../utils/academic'
import StateCbseHero from '../partialComponents/IgcseHero'
import StateCbseGrains from '../partialComponents/StateCbseGrains'
import HelmetGenerator from '../partialComponents/HelmetGenerator'
import { helmets } from '../utils/helmets'
import { useEffect } from 'react'
import GetStarted from '../partialComponents/GetStarted'
import stateWave from '../../Assets/layout_images/stateWave.png'
import { whoCanBenefit } from '../utils/whoCanBenefit'
import WhoCanBenefitHeptagon from '../partialComponents/WhoCanBenefitHeptagon'
import { useLocation } from 'react-router'
import Steps from '../partialComponents/steps'
import FeesComparision from './feescomparision'
import StudentTestimonials from '../partialComponents/StudentTestimonials'

export default function Igcse() {
    const location = useLocation()
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [location])
    return (
        <>
            <HelmetGenerator details={helmets.igcse} />
            <BasicTemplate>
                <div className="state_page_section">
                    <StateCbseHero igcse={true} />

                    {/* <StateCbseGrains /> */}

                    <StateBenefits benefits={benefits.igcse} />
                    <WhoCanBenefitHeptagon
                        page={'state'}
                        waveTop={stateWave}
                        whoCanBenefits={whoCanBenefit.state}
                    />
                    <Steps type={'state'} color={'#4394F7'} />
                    <FeesComparision/>
                    <div className="home_section">  
                    <StudentTestimonials />
                    </div>

                    <FaqContainer faqList={faqs.igcse} />
                </div>
            </BasicTemplate>
        </>
    )
}
